import Shell from '../components/Shell';

interface NotFoundPageProps {
  message?: string;
}

export default function NotFoundPage({ message }: NotFoundPageProps) {
  return (
    <Shell branding={null}>
      <h1>Enlace no encontrado</h1>
      <p>{message || 'Este enlace de verificación no existe o la dirección es incorrecta.'}</p>
    </Shell>
  );
}
